var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPreviewIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Iconly/Bold/Show"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Show",
    d: "M11.992 18.8c-3.3 0-6.273-2.308-7.945-6.175a.58.58 0 010-.457C5.717 8.305 8.687 6 11.992 6H12a7.445 7.445 0 014.589 1.637 11.388 11.388 0 013.364 4.531.58.58 0 010 .457C18.281 16.492 15.308 18.8 12 18.8zm-3.114-6.4A3.118 3.118 0 1012 9.3a3.112 3.112 0 00-3.122 3.1zm1.171 0a1.99 1.99 0 01.04-.38h.039a1.6 1.6 0 001.6-1.536 1.591 1.591 0 01.272-.025 1.935 1.935 0 11-1.95 1.941z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 15150",
    fill: "none",
    d: "M0 0h24v24H0z"
  })));
}
export default SvgPreviewIcon;